// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 81029) return "static/chunks/" + chunkId + "-f164857eb48e9973.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"44744":"949fd6f9","93344":"673e98bc"}[chunkId] || chunkId) + "." + {"19713":"fb36b13926ab3dee","44744":"fd6fcdd5a497b013","93344":"cdeb98f972ebcde8"}[chunkId] + ".js";
};